// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__13NOB","header":"MessagesList_header__3cx0R","chat":"MessagesList_chat__2bt7n"};